import { Injectable, signal } from '@angular/core';
import { MAX_INPUT_CHARACTERS } from 'projects/shared/src/lib/core/constants/content-player';

@Injectable({
  providedIn: 'root',
})
export class NumpadService {
  private focusedElement = signal<HTMLElement | null>(null);

  setFocusedElement(element: HTMLElement) {
    this.focusedElement.set(element);
  }

  insertValue(value: string) {
    const element = this.focusedElement();
    if (element) {
      element.innerText = (element.innerText + value).substring(0, MAX_INPUT_CHARACTERS);
      element.focus();
    }

    this.moveCursorToEnd(element);
  }

  applySpeechValue(value: string, replace: boolean = true): void {
    const el = this.focusedElement();
    if (!el || !value) return;

    if (replace) {
      el.innerText = value;
    } else {
      el.innerText = (el.innerText || '') + value;
    }

    const inputEvent = new Event('input', { bubbles: true });
    el.dispatchEvent(inputEvent);

    const keyupEvent = new KeyboardEvent('keyup', {
      key: 'Unidentified',
      bubbles: true,
    });
    el.dispatchEvent(keyupEvent);
  }

  deleteLastCharacter(): string | null {
    const element = this.focusedElement();
    if (element) {
      element.innerText = element.innerText.slice(0, -1);
      element.focus();
      this.moveCursorToEnd(element);

      return element.innerText;
    }
    return null;
  }

  moveCursorToEnd(element: HTMLElement | null) {
    if (element) {
      element.focus();

      const range = document.createRange();
      const selection = window.getSelection();

      range.selectNodeContents(element);
      range.collapse(false);

      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }

  public get focusedInputElement(): HTMLElement | null {
    return this.focusedElement();
  }
}
